import { render, staticRenderFns } from "./TaxEstimator.vue?vue&type=template&id=36df74f6&scoped=true&"
import script from "./TaxEstimator.vue?vue&type=script&lang=ts&"
export * from "./TaxEstimator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df74f6",
  null
  
)

export default component.exports